import { z } from 'zod';
import { EmptyValidationMessage, FormFieldSchema, mapTextField } from '@ninja/utilities';
import { CommonRegex } from '../../../../../common';
import { useAppPlatformContextOptions } from '../../../../../contexts/app';
import { prepareFieldError } from '../../../members/members-form/helpers/add-field-error';
import { DocumentsForm } from '../types';

const field = 'visaFileNumber';

export const useVisaFileNumberField = () => {
	const { translate: t } = useAppPlatformContextOptions();
	const getField = (memberId: string): FormFieldSchema<DocumentsForm> =>
		mapTextField({
			field: `${memberId}.${field}`,
			label: t('documents:fields.visa-file-number.label'),
			placeholder: t('documents:fields.visa-file-number.placeholder'),
			maxLength: 20,
			directionForInput: 'ltr',
		});

	const getValidation = () => z.string({ required_error: EmptyValidationMessage });

	const validate = (
		value: string | undefined,
		visaFileNumberUseCount: number,
		addFieldError: ReturnType<typeof prepareFieldError>
	) => {
		if (!value) {
			addFieldError({ field, message: EmptyValidationMessage });

			return;
		}

		if (!CommonRegex.visaFileNumber.test(value)) {
			addFieldError({ field, message: t('documents:fields.visa-file-number.validation.regex') });
		}

		if (visaFileNumberUseCount > 1) {
			addFieldError({ field, message: t('documents:fields.visa-file-number.validation.unique') });
		}
	};

	return {
		getField,
		getValidation,
		validate,
	};
};
